import { useEffect, useMemo, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { getToken } from '../api/client';

export const useDelivererSocket = () => {
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const socket = useMemo<Socket | null>(() => {
    const token = getToken();
    if (!token) return null;
    const socketUrl = import.meta.env.VITE_SOCKET_IO_URL || '/';
    return io(socketUrl, {
      auth: { token },
      transports: ['websocket'],
      reconnection: true
    });
  }, []);

  useEffect(() => {
    if (!socket) return;

    const onConnect = () => {
      setConnected(true);
      setError(null);
    };
    const onDisconnect = () => setConnected(false);
    const onConnectError = (err: Error) => {
      setConnected(false);
      setError(err.message);
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('connect_error', onConnectError);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('connect_error', onConnectError);
      socket.disconnect();
    };
  }, [socket]);

  return { socket, connected, error };
};

